interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	className?: string;
	children: React.ReactNode;
}

export function Button({ children, className, ...props }: ButtonProps) {
	return (
		<button
			type="button"
			{...props}
			className={`flex h-10 items-center justify-center rounded-lg bg-orange-600 px-4 py-2.5 disabled:bg-orange-200 disabled:cursor-not-allowed ${className}`}
		>
			{children}
		</button>
	);
}
